import { render, staticRenderFns } from "./card-payouts.vue?vue&type=template&id=5608822e&scoped=true&"
import script from "./card-payouts.vue?vue&type=script&lang=js&"
export * from "./card-payouts.vue?vue&type=script&lang=js&"
import style0 from "./card-payouts.vue?vue&type=style&index=0&id=5608822e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5608822e",
  null
  
)

export default component.exports